import AppApi from './AppApi';
import Customer, { CustomerName, RootCustomer } from '../models/be/Customer';
import CustomerForm from '../models/be/CustomerForm';
import Order from '../models/be/Order';
import OrderReceipt from '../models/be/OrderReceipt';
import { createQueryString } from '../lib/utils';
import { PricingTier } from '../models/CheckType';
import { CustomerLicencePricing } from '../models/be/CustomerLicencePricing';

const appApi = new AppApi();

export const getAssociatedSubCustomer = async (signal: AbortSignal): Promise<Customer> => {
	return await appApi.ajax('get', '/api/Customers/SubCustomer', null, signal);
};

export const getRootCustomer = async (signal: AbortSignal): Promise<RootCustomer> => {
	return await appApi.ajax('get', '/api/Customers/Root', null, signal);
};

export const getClientCustomer = async (customerId: number, signal: AbortSignal): Promise<Customer> => {
	const qs = createQueryString({ customerId });
	return await appApi.ajax('get', `/api/Customers/Client${qs}`, null, signal);
};

export const getClientCustomerDetails = async (customerId: number, signal: AbortSignal): Promise<CustomerName> => {
	const qs = createQueryString({ customerId });
	return await appApi.ajax('get', `/api/Customers/Name${qs}`, null, signal);
};

export const registerCustomer = async (customer: CustomerForm): Promise<string> => {
	return await appApi.ajax('put', '/api/Customers', customer, null, false);
};

export const createCustomerPricing = async (pricingModel: PricingTier[]): Promise<number> => {
	return await appApi.ajax('post', `/api/providers/create`, pricingModel);
};

export const createCustomerLicencePricing = async (
	licencePricingModel: CustomerLicencePricing
): Promise<CustomerLicencePricing> => {
	return await appApi.ajax('post', `/api/customerLicencePricing`, licencePricingModel);
};

export const getCustomerLicencePricing = async (customerId: number): Promise<CustomerLicencePricing[]> => {
	return await appApi.ajax('get', `/api/customerLicencePricing/${customerId}`);
};

export const updateCustomerLicencePricing = async (
	licencePricingModel: CustomerLicencePricing
): Promise<CustomerLicencePricing> => {
	return await appApi.ajax('put', `/api/customerLicencePricing/${licencePricingModel.id}`, licencePricingModel);
};

export const deleteCustomerLicencePricing = async (id: number): Promise<number> => {
	return await appApi.ajax('delete', `/api/customerLicencePricing/${id}`);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getOrderReceipt = async (orderId: number, signal: AbortSignal): Promise<OrderReceipt> => {
	throw new Error('We use to get this data from the PDS, but we are moving to Core API instead.');
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getOrders = async (signal: AbortSignal): Promise<Order[]> => {
	throw new Error('We use to get this data from the PDS, but we are moving to Core API instead.');
};
